import APPSearch from '@/components/component/APPSearch/APPSearch.vue'
import TableColumnSettings from '@/components/component/Reuse/TableColumnSettings/TableColumnSettings.vue'
import { mapGetters } from 'vuex'

export default{
name: 'SearchOnTop',
components:{
    APPSearch, TableColumnSettings
 },
 computed: {
   ...mapGetters({
     showTableSettings: 'getShowTableSettings'
   })
 },
 props: {
     clickedOn: {
         type: String,
         required: true
     },
     columns: {
        type: Array,
        default: [],
        required: true
      },
      tableSettingOptions: {
        type: Array,
        default: [],
        required: true
      },
      updateColumnsInTable: {
        type: Function,
        required: true
      },
      category: {
        type: String,
        required: true
      }
      // showTableSettings: {
      //     type: Boolean,
      //     default: true
      // }
    }
}